const pagination = () => ({
    limit: 10,
    offset: 0,
    length: 0,
    pageNumber: 0,
});

const dataCreateMesin = () => ({
    id: "",
    serial: "0",
    nama: "",
    jenis: 1,
    door: 0,
    tag: []
});

const state = {
    listSnapMesin: [],
    listTagMesin: [],
    listMesinUrut: [],
    reportConnectionMesin: [],
    latestVersionMesin: {},
    layananByAid: {},
    detailMesin: {},
    createMesinData: dataCreateMesin(),

    // filter
    pagination: pagination(),
    searchKey: "",
    jenis: 0
}

export {
    state as default,
    pagination,
    dataCreateMesin
}